import { statuses } from "../../../constants";

export const formatThaiDate = (timestamp, includeSeconds = true) => {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: includeSeconds ? "2-digit" : undefined,
  });
};

export const getStatusBgClass = (status) => {
  if (status === statuses.APPROVE) return "bg-[rgb(59,176,101)] text-white";
  if (status === statuses.CANCEL) return "bg-[#c15b78] text-white";
  if (status === statuses.PAID) return "bg-[#4DA1A9] text-white";
  if (status === statuses.PENDING) return "bg-[#FAB12F] text-slate-900";
  return "bg-slate-500 text-white";
};

export const formatDatetimeLocal = (ts) => {
  if (!ts) return "";
  const d = new Date(ts);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
